import { curriculum } from '@/content/curriculum';
import type { LearningObjective, LessonStep } from '@/content/schema';

export type Rule = Extract<LessonStep, { type: 'rule' }>;

/** The rules of the lessons of these objectives, in curriculum order. */
export function rulesOf(objectives: LearningObjective[]) {
  return objectives.flatMap((objective) => {
    const steps = curriculum.lesson(objective.id)?.steps ?? [];
    return steps
      .filter((step): step is Rule => step.type === 'rule')
      .map((rule) => ({ rule, objective }));
  });
}
